import * as React from 'react'
import Heading from 'components/shared/Heading'
import Paragraph from 'components/shared/Paragraph'
import PropTypes from 'prop-types'
import './index.scss'

const OrderDetails = ({ orders, additionalInfo, doorbell }) => {
  return (
    <div className="order-details">
      <Heading level={3}>Oppdragsinformasjon</Heading>
      <Heading level={4}>Booliginformasjon</Heading>
      <Paragraph>
        <>
          {doorbell && (
            <>
              <strong>Navn på ringeklokke:</strong> {doorbell} <br />
            </>
          )}
          {additionalInfo && (
            <>
              <strong>Annet info:</strong> {additionalInfo} <br />
            </>
          )}
        </>
      </Paragraph>
      <Heading level={4}>Ordrekommentarer</Heading>
      {!orders || !orders.length ? (
        <div>Ingen ordre på oppdrag</div>
      ) : (
        <ul>
          {orders.map((order) => {
            return order.customerComment ? (
              <li key={order.id}>{order.customerComment}</li>
            ) : null
          })}
        </ul>
      )}
    </div>
  )
}

OrderDetails.propTypes = {
  orders: PropTypes.array,
  additionalInfo: PropTypes.string,
  doorbell: PropTypes.string,
}

export default OrderDetails
